import React from 'react';
import PropTypes from "prop-types";
import GenericLabel from '../GenericLabel';
import { dataAttribsForEl, formatClassName } from '../../Util';
import CardTitle from './CardTitle';
import AttentionGrabber from '../AttentionGrabber';

export default class CardTextBox extends React.Component {
  static propTypes = {
    alertMiniCard: PropTypes.bool,
    allowSecondaryDetailLineBreaks: PropTypes.bool,
    attentionGrabber: PropTypes.shape({
      className: PropTypes.string,
      icon: PropTypes.string,
      label: PropTypes.string,
      type: PropTypes.string
    }),
    corner: PropTypes.string,
    dismissable: PropTypes.bool,
    dismissAction: PropTypes.func,
    description: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.node
    ]),
    descriptionClass: PropTypes.string,
    descriptionDataAttributes: PropTypes.object,
    hasLabel: PropTypes.bool,
    hasMedia: PropTypes.bool,
    hasRichTextContent: PropTypes.bool,
    secondaryDetail: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.arrayOf(PropTypes.object)
    ]),
    title: PropTypes.string,
    titleDataAttributes: PropTypes.object,
    titleIcon: PropTypes.string,
    titleIconSize: PropTypes.string,
    titleSize: PropTypes.oneOf([14, 16, 18]),
    type: PropTypes.oneOf(['mini', 'narrow', 'medium', 'wide', 'extra-wide'])
  };

  static defaultProps = {
    allowSecondaryDetailLineBreaks: false,
    corner: 'none',
    descriptionDataAttributes: {},
    hasRichTextContent: false
  };

  renderSecondaryDetail = () => {
    const { allowSecondaryDetailLineBreaks, secondaryDetail } = this.props;
    if (secondaryDetail && Array.isArray(secondaryDetail)) {
      return (
        <div className="card-secondary-detail">{secondaryDetail.map((detail, index) =>
          <GenericLabel key={index} {...detail} />)}
        </div>
      )
    } else {
      return <GenericLabel allowLineBreaks={allowSecondaryDetailLineBreaks} className="card-secondary-detail" label={secondaryDetail} />
    }
  }

  getTextBoxClasses = () => {
    const { hasLabel, hasMedia, type, alertMiniCard, corner } = this.props;
    return formatClassName([
      'card-text',
      `card-text-${type}`,
      { 'has-label': hasLabel },
      { 'has-media': hasMedia },
      { 'alert-mini-card': alertMiniCard },
      `card-corner-${corner}`
    ])
  }

  getDescriptionClasses = () => {
    const { descriptionClass } = this.props;
    return formatClassName([
      'card-description',
      descriptionClass
    ]);
  }

  renderDescription() {
    const { description, descriptionDataAttributes: { context, optionalAttributes }, hasRichTextContent } = this.props;
    const descriptionClasses = this.getDescriptionClasses();
    const descriptionDataAttributes = dataAttribsForEl(context, optionalAttributes);

    if (!description) return null;

    return hasRichTextContent ? (
      <div 
        dangerouslySetInnerHTML={{ __html: description }} 
        className={descriptionClasses} 
        {...descriptionDataAttributes} 
      />
    ) : (
      <div className={descriptionClasses} {...descriptionDataAttributes}>
        {description}
      </div>
    );
  }

  renderAttentionGrabber = () => {
    const { attentionGrabber, description } = this.props;

    if (!attentionGrabber) return null;

    return (
      <AttentionGrabber 
        {...attentionGrabber} 
        className={formatClassName([ 
          attentionGrabber.className, 
          { 'm-b-10': !!description } 
        ])}
      />
    );
  }

  render() {
    const { title, secondaryDetail, titleDataAttributes, titleIcon, titleIconSize, titleSize } = this.props;
    const textBoxClasses = this.getTextBoxClasses();

    return (
      <div className={textBoxClasses}>
        {title &&
          <CardTitle size={titleSize} icon={titleIcon} iconSize={titleIconSize} titleDataAttributes={titleDataAttributes}>
            {title}
          </CardTitle>}
        {secondaryDetail && this.renderSecondaryDetail()}
        {this.renderAttentionGrabber()}
        {this.renderDescription()}
      </div>
    )
  }
}
